export enum EPositionVertical {
	TOP = 'top',
	BOTTOM = 'bottom',
}

export enum EPositionHorizontal {
	LEFT = 'left',
	RIGHT = 'right',
}
